import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import { useModal } from "@ebay/nice-modal-react";
import FormCompany from "./FormCompany";

function CompanyModalBody({ form }) {
    const modal = useModal();
    const { onClose } = useModalHelper(modal);

    return (
        <>
            <FormCompany
                form={form}
                onSend={(e) => {
                    onClose();
                    modal.resolve(e);
                }}></FormCompany>
        </>
    );
}
export default CompanyModalBody;
